/* ============
 * Locale Module Mutations
 * ============
 *
 */

import {
  SET_LOCALE
} from './mutation-types'

export default {
  [SET_LOCALE] (state, locale) {
    state.current = locale
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/locale/mutations.js